import type { Prototype } from "./api";

export function deriveTagSuggestions(prototypes: Prototype[]): string[] {
  const set = new Set<string>();
  for (const p of prototypes) for (const t of p.tags ?? []) set.add(t);
  return [...set].sort();
}
